import React, { useState } from 'react';
import * as Yup from 'yup';
import { Form, Button, Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import { createOrganization } from '../../actions/organization';
import { alertError, alertSuccess } from '../../helpers/errorHandling';
import { useDispatch } from 'react-redux';
import InnerLoader from '../../Components/Common/InnerLoader';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreateOrganization = () => {
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setShow(false);
    resetFormValues();
  };
  const handleShow = () => setShow(true);

  const formik = useFormik({
    initialValues: {
      name: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Name is required'),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);

        const inputData = {
          input: {
            ...values,
          },
        };

        const res = await createOrganization(inputData, dispatch);
        if (res?.organizationId) {
          alertSuccess('Organization created successfully');
          setTimeout(() => {
            handleClose();
          }, 1000);
        } else {
          alertError({ message: 'Failed,Please try again later' });
        }
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } catch (e) {
        console.log(e);
      }
    },
  });

  const {
    values,
    handleChange,
    handleBlur,
    touched,
    errors,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = formik;

  const resetFormValues = () => {
    resetForm({
      values: {
        name: '',
      },
    });
  };

  return (
    <>
      <span className="" onClick={handleShow}>
        <i className="bx bx-plus"></i>
      </span>

      <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton className="border-bottom pb-3">
          <Modal.Title>Create New Organization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate onSubmit={handleSubmit}>
            <Form.Group controlId="name" className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={values?.name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched?.name && !!errors?.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Button type="submit" className="mt-2">
              Create
            </Button>
          </Form>
          {loading && <InnerLoader />}
          {/* <ToastContainer /> */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CreateOrganization;
